(function () {
  var racine = document.documentElement;
  var suivie = null;
  var observateur = null;

  function publier(hauteur) {

    racine.style.setProperty('--cm-annonce-hauteur', hauteur.toFixed(1) + 'px');
  }

  function mesurer() {
    var barre = document.querySelector('.cc-announcement');

    if (!barre) {
      publier(0);
      return;
    }

    if (getComputedStyle(barre).position === 'static') {
      publier(0);
      return;
    }

    publier(barre.getBoundingClientRect().height);

    if (suivie !== barre && observateur) {
      if (suivie) observateur.unobserve(suivie);
      observateur.observe(barre);
      suivie = barre;
    }
  }

  if (typeof ResizeObserver === 'function') {
    observateur = new ResizeObserver(mesurer);
  }

  mesurer();
  document.addEventListener('DOMContentLoaded', mesurer);
  window.addEventListener('load', mesurer);
  window.addEventListener('resize', mesurer);
  document.addEventListener('shopify:section:load', mesurer);
  document.addEventListener('shopify:section:unload', mesurer);

  if (typeof MutationObserver === 'function') {
    new MutationObserver(mesurer).observe(document.body || racine, {
      attributes: true,
      attributeFilter: ['class'],
    });
  }
})();
